import { render, staticRenderFns } from "./GeneralData.vue?vue&type=template&id=25bb9b1c&scoped=true&"
import script from "./GeneralData.vue?vue&type=script&lang=js&"
export * from "./GeneralData.vue?vue&type=script&lang=js&"
import style0 from "./GeneralData.vue?vue&type=style&index=0&id=25bb9b1c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bb9b1c",
  null
  
)

export default component.exports